import { render, staticRenderFns } from "./SupportUser.vue?vue&type=template&id=62db4264&scoped=true&"
import script from "./SupportUser.vue?vue&type=script&lang=js&"
export * from "./SupportUser.vue?vue&type=script&lang=js&"
import style0 from "./SupportUser.vue?vue&type=style&index=0&id=62db4264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db4264",
  null
  
)

export default component.exports